import { Tween } from "@westpierstudio/luma/createjs";
import { Point } from "@westpierstudio/luma/layout/DefaultLayout";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { VSOption } from "servertypes/SharedTypes";
import { Signal } from "type-signals";
import { Spine } from "pixi-spine";
import { Container, Text } from "pixi.js";
import { addToSpineSlot } from "utils/Misc";
import { minimumHeightSpecSelector } from "utils/Responsive";
import { BoundedContainer, ImplementBoundedContainer } from "utils/BoundedContainer";

class VSRespinPanelSignals {
    showComplete = new Signal();
}

export class VSRespinPanel extends View {
    private panel: Spine & Container;
    private locations!: {dragons: Point, pandas: Point};
    signals = new VSRespinPanelSignals();
    panelLabel: Text;
    labelContainer!: BoundedContainer;

    constructor(protected override readonly services: GameServices) {
        super(services);

        const {resources, factory} = services;

        const spec = resources.getSpec(`vsrespinpanel`);
        factory.applySpec(this, spec);

        this.locations = {
            dragons: spec.dragons,
            pandas: spec.pandas
        };

        this.panel = factory.createSpine(spec.respinPanel, this);
        this.panelLabel = factory.createText(resources.getMessage(`vsRespinAwarded`), spec.respinPanelText);
        this.labelContainer = ImplementBoundedContainer(this.panelLabel, spec.maxBounds.label, true);

        addToSpineSlot(this.panel, this.labelContainer, `dynamic-slot`);

        this.visible = false;

        this.resize();
        services.layout.onResize.add(()=>this.resize());
    }

    show(index: VSOption): void {

        const {resources, factory} = this.services;
        const {staticTime, outTime} = resources.getSetting(`vsRespinPanel`);

        const spec = (index === VSOption.DRAGON) ? this.locations.dragons : this.locations.pandas;
        factory.applySpec(this.panel, spec);

        this.visible = true;
        this.panel.state.setAnimation(0, `intro`, false);

        Tween.get(this)
        .wait(staticTime)
        .call(() => {
            this.panel.state.setAnimation(0, `outro`, false);
        })
        .wait(outTime)
        .call(() => {
            this.visible = false;
            this.signals.showComplete.dispatch();
        });
    }

    override reset(): void {

        Tween.removeTweens(this);
        this.visible = false;
    }

    resize() {
        const spec = this.services.resources.getSpec(`vsrespinpanel`);
        const portraitSpec = minimumHeightSpecSelector(this.services, spec.portrait);
        this.services.factory.applySpec(this, portraitSpec);
    }
}